export const AsnwerExpression_g = /%A\{([^¥}]+)\}/g;
export const AsnwerExpression = /%A\{([^¥}]+)\}/;
export const AsnwerExpressionPerfectMatch = /^%A\{([^¥}]+)\}$/;
export const TextType = {
	Answer : 'Answer',
	NotAnswer : 'NotAnswer',
	Invalid : 'Invalid'
};
export const findoutTextType = (text) => {
	if(text==='') return TextType.Invalid;
	if(AsnwerExpressionPerfectMatch.test(text)) return TextType.Answer;
	if(AsnwerExpression.test(text)) return TextType.Invalid;
	return TextType.NotAnswer;
};

const RemoveAnswerExpression = (text) =>{
	const results = text.match(AsnwerExpression);
	if(!results || results.length<2) return '';
	return results[1];
};

export const removeAnswerExpressions = (text) => {
	let replaced = text;
	while(AsnwerExpression_g.test(replaced)){
		replaced = replaced.replace(AsnwerExpression_g, match => {
			return RemoveAnswerExpression(match);
		});
	}
	return replaced;
};

export const findAnswers = (original) => {
	const answerExpressions = original.match(AsnwerExpression_g);
	if(!answerExpressions) return {
		answerExpressions:null,
		answers:null
	};
	return {
		answerExpressions:answerExpressions,
		answers:answerExpressions.map((answer)=>removeAnswerExpressions(answer))
	};
};

export const buildQuestion = (original,
	questionFormatter=(question)=>question, 
	answerFormatter=(answer)=>answer) => {
	const {answerExpressions, answers} = findAnswers(original);
	if(!answerExpressions) return [questionFormatter(original,0)];
	const expression = answerExpressions
		.map(text=>text.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'))
		.join('|');
	
	const questionBase = original.split(new RegExp(expression));
	const answersUnique = Array.from(new Set(answers));
	const answerFormatMapper = answersUnique.reduce((obj,answer,i)=>{
		obj[answer] = answerFormatter(answer,i);
		return obj;
	},{});
	const answerLabels = answers.map(a=>answerFormatMapper[a]);
	const questionBaseLabel = questionBase.map(questionFormatter);
	let question = [];
	for(let i = 0; i < questionBase.length; ++i){
		question.push(questionBaseLabel[i]);
		if( i < answerExpressions.length) question.push(answerLabels[i]);
	}
	return question.filter(Boolean);
};